import ProductInfo from 'components/GlobalModals/SavedForLaterModal/ProductInfo/ProductInfo.f';

export default ProductInfo;
